import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 13.45 11.531"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fd6d48",
  d: "M6.69.001a.751.751 0 0 0-.616.365L.095 10.44a.712.712 0 0 0 0 .728.753.753 0 0 0 .649.363h11.95a.753.753 0 0 0 .649-.363.712.712 0 0 0 0-.728L7.363.366A.753.753 0 0 0 6.69.001zm.035 3.043a.48.48 0 0 1 .48.48v4.484a.48.48 0 1 1-.961 0V3.524a.48.48 0 0 1 .481-.484zm0 5.765a.48.48 0 1 1-.48.48.48.48 0 0 1 .48-.481z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };